<template>
	<div class="gb-page">
		<HeadNav selectedLanguage="en" page="disclaimer" />

		<article class="gb-legal">
			<hh1>Disclaimer</hh1>
			<p>
				<a class="jump-url" href="https://gbappss.co/">GB Apps</a>
				provides information, guides, and resources about GB WhatsApp and related Android applications.
			</p>
			<p>We would like to clarify the following:</p>
			<p>
				GB WhatsApp is a third-party modified application and is not an official WhatsApp product. GB Apps is
				not affiliated with Meta, WhatsApp, or any official service.
			</p>

			<hh2>Third-Party Applications</hh2>
			<p>
				Modified applications may have different features, update methods, and compatibility compared with
				official applications.
			</p>
			<p>
				Users should understand the potential risks of installing third-party APK files and download
				applications carefully.
			</p>

			<hh2>No Guarantee</hh2>
			<p>
				While we try to provide accurate and updated information, we cannot guarantee that all applications,
				features, or installation methods will work perfectly on every device.
			</p>
			<p>Users are responsible for their own decisions when downloading and installing applications.</p>

			<hh2>Website Information</hh2>
			<p>All information on GB Apps is provided for educational and informational purposes.</p>
		</article>
	</div>
</template>

<script>
import '@/css/base.scss'
import '@/css/index.scss'
import '@/css/gbappss.scss'
import HeadNav from '@/components/HeadNav.vue'

export default {
	name: 'Disclaimer',
	components: { HeadNav },
}
</script>
